import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {DashboardComponent} from "./dashboard/dashboard.component";
import {AdminPanelComponent} from "./admin-panel.component";
import {TeamsComponent} from "./teams/teams.component";
import {LeagueComponent} from "./league/league.component";
import {AuthGuard} from "../auth/services/auth.guard";
import {Role} from "../auth/models/Role";
import {UsersComponent} from "./users/users.component";
import {NewsComponent} from "./news/news.component";
import {CreateNewsComponent} from "./news/create-news/create-news.component";
import {EditNewsComponent} from "./news/edit-news/edit-news.component";
import {CategoriesComponent} from "./categories/categories.component";
import {StandingsComponent} from "./standings/standings.component";
import {NationalGamesComponent} from "./national-games/national-games.component";
import {VolunteersComponent} from "./volunteers/volunteers.component";
import {FfkTvComponent} from "./ffk-tv/ffk-tv.component";
import {AdminProfileComponent} from "./admin-profile/admin-profile.component";
import {CoachApplicationsComponent} from "./coach-applications/coach-applications.component";
import {CoursesComponent} from "./courses/courses.component";

const routes: Routes = [
  {
    path: 'admin-panel', component: AdminPanelComponent, canActivate: [AuthGuard], data: { roles: [Role.Admin, Role.Coach] },
    children: [
      {path: 'admin-dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-news-categories', component: CategoriesComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-news', component: NewsComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-news/:id', component: EditNewsComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-create-news', component: CreateNewsComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-teams', component: TeamsComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-league', component: LeagueComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-volunteers', component: VolunteersComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-coach-applications', component: CoachApplicationsComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin, Role.Coach]}},
      {path: 'admin-courses', component: CoursesComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-standings', component: StandingsComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-manage-users', component: UsersComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-national-games', component: NationalGamesComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-ffk-tv', component: FfkTvComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin]}},
      {path: 'admin-profile', component: AdminProfileComponent, canActivate: [AuthGuard], data: {roles: [Role.Admin, Role.Coach]}},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {
}
